import { SortOrder } from 'antd/es/table/interface';

export const normalizeSortParams = (
  identifier: string,
  order: SortOrder | undefined
): string | undefined => {
  if (!order) {
    return undefined;
  }

  return `${identifier}:${order}`;
};
